export default __webpack_public_path__ + "static/media/logo.f744bca0.png";